import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema } from './config';


const EditProduct = ({dialog = false, ignore_id = false}) => {
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

  return (
    <EditForm title={"Product"} initialValues={initialValues} fields={formFields} schema={schema} url={"products"} dialog={dialog} ignore_id={ignore_id}>
      
    </EditForm>
  );
}

export default EditProduct;